"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var SeoBlockTypes;
(function (SeoBlockTypes) {
  SeoBlockTypes["Review"] = "review";
  SeoBlockTypes["BestProduct"] = "bestproduct";
  SeoBlockTypes["ExpertOpinion"] = "expertOpinion";
  SeoBlockTypes["TopOffers"] = "topOffers";
  SeoBlockTypes["FAQ"] = "faq";
  SeoBlockTypes["Html"] = "html";
  SeoBlockTypes["Banner"] = "seoBanner";
  SeoBlockTypes["Prefooter"] = "prefooter";
})(SeoBlockTypes || (SeoBlockTypes = {}));
var _default = SeoBlockTypes;
exports.default = _default;